import requestFeatureAvailability from './request-feature-availability';

export default {
  requestFeatureAvailability,
};
